import React, { useState, useRef, useEffect } from "react";
import * as styles from "../styles/components/tooltip.module.css";
import { buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";

const Tooltip = ({ asset, tooltipContent  }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef(null);
  let showRight = tooltipContent?.title?.includes("Dedicated")
  return (
    <span
      className={styles.tooltipContainer}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {/* Tooltip Trigger - Display asset image */}
      {asset && (
        <img
          src={imageUrlFor(buildImageObj({ asset })).auto("format").url()}
          alt="tooltip trigger"
        />
      )}

      {/* Tooltip Content - Show on hover */}
      {isVisible && (
        <div
          ref={tooltipRef}
          className={`${styles.tooltip} ${showRight ? styles.tooltipRight : ""}`}
        >
          {tooltipContent ? (
            <div>
              <ul className={styles.tooltipList}>
                {tooltipContent.content.map((item) => (
                  <li key={item._key}>
                    <strong>{item.label}</strong> {item.value}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      )}
    </span>
  );
};

export default Tooltip;
